module.exports = __webpack_public_path__ + "static/img/tab5spic.9dd69eae.png";